import axios from 'axios';
import { get } from 'lodash';

import { routes } from '../common/utils/routes';
import { storage } from '../common/utils/storage';

const { REACT_APP_PYTHON_API_ENDPOINT, API_TIME_OUT } = process.env;

const PythonApiClient = axios.create({
  baseURL: REACT_APP_PYTHON_API_ENDPOINT,
  timeout: (API_TIME_OUT && parseInt(API_TIME_OUT, 10)) || 30000,
});

PythonApiClient.interceptors.request.use(
  (config: any) => {
    const authorizationData = storage.getToken();
    if (authorizationData) {
      config.headers.Authorization = `Bearer ${authorizationData}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

PythonApiClient.interceptors.response.use(
  (response: any) => {
    return response.data;
  },
  (error: any) => {
    const message = get(error, 'response.data.message');

    if (message === 'token.invalid') {
      localStorage.removeItem('persist:root');
      storage.removeToken();
      window.location.pathname = routes.LOGIN;
    }

    return Promise.reject(error);
  },
);

export default PythonApiClient;
